import React, { Component } from 'react';
import '../../css/App.css';
import { observer } from 'mobx-react';
import RadiosGroup from './RadiosGroup'
import TextInput from './TextInput'
import Address from './Address'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';




const styles = {   
  card:{
    marginTop: "15px",    
  }
}

const radIsReceiptSelections = [
    {value:"Y", label:"開立郵寄"},
    {value:"N", label:"開立不用郵寄"}
    
]

class CardGeneralInformation extends Component {
  render() {
    const { classes } = this.props;

    return (   
        <Card
        className={classes.card}
        >
          <TextInput
            title = "捐款金額*"
            objectKey = "DonationAmount"
            placeholder = "新台幣(元)"
          />
          <TextInput
            title = "捐款人姓名*"
            objectKey = "txtName"
            placeholder = "女士 / 先生"
          />
          <TextInput
            title = "身分證字號*"
            objectKey = "txtIdentify"
            placeholder = "請輸入英文及數字"
          />
          <TextInput
            title = "聯絡電話*"
            objectKey = "txtPhone"
            placeholder = "請輸入數字"
          />
          <TextInput
            title = "收據抬頭*"
            objectKey = "txtTitle"
            placeholder = "請輸入收據抬頭"
          />
          <RadiosGroup
            title = "收據*"
            objectKey = "radIsReceipt"
            selections = {radIsReceiptSelections}
          />
          <Address
            title = "收據郵寄地址*"
            objectKey = "txtAddress"
          />
            <TextInput
            title = "備註"
            objectKey = "ShortDesc"
            placeholder = "請輸入備註"
            attention = "為尊重捐款人的意願，若不想列示於捐款芳名錄上或收到感謝函，煩請註記於備註欄位中，本院會配合處理，謝謝您的善心！"
          />
        </Card>
      
    );
  }
}

export default withStyles(styles)(observer(CardGeneralInformation));
